// 页面的tabs
export const tabs_list = [
    { 
      title: '费用nature',
      value:'nature' 
    },
    { 
      title: '职能',
      value:'functional' 
    },
    { 
      title: '产品',
      value:'production' 
    },
    {
      title: '用途',
      value:'purpose' 
    },
    { 
      title: '会计科目',
      value:'accountant' 
    },
    { 
      title: '分析科目',
      value:'analyse' 
    }
]

// 费用nature table_headers
export const nature_header_fields = [
    {
      text: '费用名称',
      align: 'center',
      value: 'name',
      sortable: false,
    },
    {
      text: '关键词',
      align: 'center',
      value: 'synonyms',
      sortable: false,
    },
    {
      text: '操作',
      align: 'center',
      value: 'actions',
      sortable: false,
    }
  ]
export const functional_header_fields = [
  {
    text: '职能名称',
    align: 'center',
    value: 'name',
    sortable: false,
  },
  {
    text: '操作',
    align: 'center',
    value: 'actions',
    sortable: false,
  }
]
export const item_type_header_fields = [
  {
    text: '产品类型',
    align: 'center',
    value: 'name',
    sortable: false,
  },
  {
    text: '操作',
    align: 'center',
    value: 'actions',
    sortable: false,
  }
]
export const use_type_header_fields = [
  {
    text: '用途名称',
    align: 'center',
    value: 'name',
    sortable: false,
  },
  {
    text: '操作',
    align: 'center',
    value: 'actions',
    sortable: false,
  }
]